import React from 'react';
import getSuitCSSClasses from '../../structural-components/Header/utils/getSuitCSSClasses';
import { toast, ToastContentProps, ToastOptions, ToastContainer } from 'react-toastify';
import { ErrorToast, SuccessToast, WarningToast, InfoToast } from '../../components/Toast';

type TToastNotificationProps = {
  type: 'success' | 'error' | 'warning' | 'info';
  description: string;
  options?: ToastOptions;
};

export const ConfiguredToastContainer = () => (
  <ToastContainer
    position="bottom-center"
    hideProgressBar
    draggable={false}
    closeButton={false}
    toastClassName={getSuitCSSClasses({ namespace: 'hz', name: 'Toast-message' })}
    className={getSuitCSSClasses({ namespace: 'hz', name: 'Toast-root' })}
    newestOnTop={true}
    autoClose={6000}
    limit={1}
  />
);

const toastNotification = ({ type = 'success', description = '', options }: TToastNotificationProps) => {
  if (type === 'success') {
    toast(
      ({ closeToast }: ToastContentProps) => (
        <SuccessToast icon="checkmark-circle" onClose={closeToast}>
          {description}
        </SuccessToast>
      ),
      options,
    );
  }

  if (type === 'error') {
    toast(
      ({ closeToast }: ToastContentProps) => (
        <ErrorToast icon="alert" onClose={closeToast}>
          {description}
        </ErrorToast>
      ),
      options,
    );
  }

  if (type === 'warning') {
    toast(
      ({ closeToast }: ToastContentProps) => (
        <WarningToast icon="alert" onClose={closeToast}>
          {description}
        </WarningToast>
      ),
      options,
    );
  }

  if (type === 'info') {
    toast(
      ({ closeToast }: ToastContentProps) => (
        <InfoToast icon="info" onClose={closeToast}>
          {description}
        </InfoToast>
      ),
      options,
    );
  }
};

export default toastNotification;

export const dismissToast: (toastId?: string | number) => void = toast.dismiss;
